import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import {Subscription} from 'rxjs';
import {Redirect, Switch, useHistory, useLocation} from 'react-router-dom';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT

import {LinearProgress} from '@material-ui/core';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import NavRoutes from '../../../../constants/route/NavRoutes';
import TopAppBar from '../../../../components/system/TopAppBar/TopAppBar';
import CustomRoute from '../../../../constants/route/CustomRoute';
import {APP} from '../../../../style/variable';
import {BASE_ROUTE_ADMIN} from '../../../../constants/route/BaseRoute';
import {getMyProfile, logoutUserFromWeb} from '@shared/services/CommonServices';
import {useSelector} from 'react-redux';
import useInterval from './CustomHook';
import {
  _initUserInfo,
  _initUserPermissions,
  _userGroups,
  _userType,
  _groupId,
  _setDefaultGroupAfterAuth
} from '@shared/store/actions/AuthActions';
import {_setUserHasAdminRoleAndReportsEnable} from '@shared/store/actions/ReportsActions';
import {
  _patientsShared,
  // _setBillingClinicId,
  _groupType,
  _setClinics
} from '@shared/store/actions/ClinicActions';
import {_messageCount} from '@shared/store/actions/NewMessagesActions';
import {
  AppPermissions,
  CCMConstants,
  MENUOPTIONS,
  moduleNameMapper,
  moduleNameTransMapperByModuleId,
  ORGANIZATION_GROUP_TYPES,
  PriorAuthConstants
} from '@shared/constants/Mapping';
// import CustomBadge from './CustomBadge';
import {Permission} from '@shared/services/PermissionService';
import Loader from '@components/framework/loader/Loader';
import {CustomPopOverListItemType} from '@components/system/CustomPopOver/CustomPopOver';
import CustomBadge from './CustomBadge';
import AlertBox from '@components/system/AlertBox/AlertBox';
import {CommunicationService} from 'src/service/CommunicationService';
import Storage from 'src/utils/Storage';

import PatientsDetailsHome from '../PatientDetailsHome/PatientDetailsHome';
import {
  getAllClinics,
  getGroupLevelEnabledModules
} from '@shared/services/ClinicServices';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import DraggableCCMCard from '../ChronicCareManagement/module-components/DraggableCCMCard/DraggableCCMCard';
import {_setUpcomingAppointment} from '@shared/store/actions/CCMTimerActions';
import InitSharedRepo from '../../../../../../shared';
import AuthUtils from 'src/utils/AuthUtils';
// eslint-disable-next-line max-len
import DraggableTicketingSystemTicketTimerCard from '../TicketingSystem/TicketingSystemTimer/DraggableTicketingSystemTicketTimerCard/DraggableTicketingSystemTicketTimerCard';
import {_startTicketTimer} from '@shared/store/actions/TicketTimerActions';
import usePriorAuthPermission from '../PriorAuthorization/hooks/usePriorAuthPermission';
import useClaimsTicketsPermissions from '../ClaimsTickets/hooks/useClaimsTicketsPermissions';
import {_setSelectedGroupEnabledModules} from '@shared/store/actions/GroupActions';
import {State} from '@shared/store/reducers/Index';
import useReferralsTicketsPermissions from '../ReferralsTickets/hooks/useReferralsTicketsPermission';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      height: '100%',
      backgroundColor: APP.COLOR.BACKGROUND.SCREEN
    },
    dropDownErrorClass: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.5rem',
      paddingTop: '1rem',
      paddingLeft: '0.5rem'
    },
    appBar: {
      boxShadow: 'none',
      '@media (min-width:0px) and (orientation: landscape)': {
        height: theme.mixins.toolbar.minHeight
      },
      [theme.breakpoints.up('md')]: {
        width: `100%`
      }
    },
    content: {
      backgroundColor: APP.COLOR.DEFAULT.WHITE,
      paddingTop: theme.mixins.toolbar.minHeight,
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      overflowY: 'hidden'
    },
    notificationLabel: {
      display: 'flex',
      cursor: 'pointer'
    },
    custom: {
      position: 'relative',
      top: '7px',
      left: '8px'
    }
  })
);

// FIXME: ADD INTERFACE FOR THE PROPS
const Home = (props: any): React.ReactElement => {
  const location = useLocation();
  const history = useHistory();
  const [showNewUpdateAlert, setNewUpdateAlert] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [load, setLoad] = useState(true);
  const [tab, setTab] = useState(0);
  const [statusCode, setStatusCode] = useState(0);
  const [tabs, setTabs] = useState<any[]>([]);
  const [selectedGroup, setSelectedGroup] = React.useState<any>({});
  const {userType, groupId, userPermissions} = props;
  // To get the login token when user logs in
  const loginToken = useSelector((state: any) => state.auth.authToken);
  const defaultGroupIdAfterAuth = useSelector(
    (state: State) => state.auth.defaultGroupIdAfterAuth
  );

  // const [appointmentsData, setAppointments] = React.useState<any>({});
  const userHasAdminRoleAndReportsEnable = useSelector(
    (state: any) => state.reports.user_has_admin_role_and_reports_enable
  );
  const count = useSelector((state: any) => state.newMessages.count);
  const subscription = React.useRef<Subscription>();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  // const [popOverItem, setPopOverItem] = React.useState<any>('');
  // Id
  // const [, setId] = React.useState<any>(0);
  const {isTimerRunning: ccmIsRunning} = useSelector(
    (state: any) => state.ccmTimer
  );
  const {isTicketTimerRunning: ticketIsRunning} = useSelector(
    (state: any) => state.PriorAuthTicketTimer
  );
  const userGroups: any = useSelector(
    (state: any) => state.auth.userGroups || []
  );

  const switchTab: any = useSelector(
    (state: any) => state.auth.switch_tab || false
  );
  const patientDetailsDrawerOpen = useSelector(
    (state: any) => state.patientDetailsDrawer?.open
  );
  const classes = useStyles();

  // const type: string = 'admin';
  const groupType = useSelector((state: any) => state.clinics.groupType);

  const clinicsList = useSelector((state: any) => state.clinics.list);

  const accessableModules: any = useSelector(
    (state: any) => state.group.selectedGroupEnabledModules || []
  );

  const patientsEnable: boolean =
    userPermissions?.[groupId]?.['group']?.[
      AppPermissions.MENU_PERMISSIONS.PATIENTS
    ];

  React.useEffect(() => {
    if (userGroups.length) {
      setSelectedGroup(
        userGroups.find((userGroup: any) => userGroup.id == groupId) ?? 0
      );
    }
  }, [groupId, userGroups]);
  const {enqueueSnackbar} = useSnackbar();

  // Update clinics list when groupId changes
  React.useEffect(() => {
    const fetchAllClinics = async () => {
      getAllClinics(groupId)
        .then((res: any) => {
          if (res && res?.data && res?.data?.rows) {
            dispatch(_setClinics(res.data.rows));
          }
        })
        .catch((error: any) => {
          enqueueSnackbar(
            t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
            SnackBarConfig('e')
          );
        });
    };
    // Fetch for clinics only if the users has access to the current group.
    if (Array.isArray(userGroups) && userGroups.length > 0) {
      const hasAccessToGroup = userGroups.some(
        (group: any) => group?.org_group_id == groupId
      );
      if (groupId && hasAccessToGroup) {
        fetchAllClinics();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId, userGroups]);

  // To reduce the multiple api count using useRef hook
  const meApiCalled = React.useRef(true);

  let defaultTabs: any =
    userType === 'admin'
      ? [
          {
            name: AppPermissions.DASHBOARD.NAME,
            label: t('TOP_NAV_COMMON.TABS.DASHBOARD'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.DASHBOARD}`
          },
          {
            name: AppPermissions.CLINIC_GROUP.NAME,
            label: t('TOP_NAV_COMMON.TABS.CLINIC_GROUPS'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.CLINICS}`
          },
          {
            name: AppPermissions.ADMIN.NAME,
            label: t('TOP_NAV_COMMON.TABS.ADMINS'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.ADMIN}`
          },
          // ADDED REPORTS TAB TO SUPER ADMIN USERS.
          {
            name: AppPermissions.REPORTS.NAME,
            id: 'REPORTS',
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.REPORTS}`,
            label: t('TOP_NAV_COMMON.TABS.REPORTS')
          },
          {
            name: AppPermissions.SCHEDULED_JOBS.NAME,
            label: t('TOP_NAV_COMMON.TABS.SCHEDULED_JOBS'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.SCHEDULED_JOBS}`
          },
          {
            name: AppPermissions.HOLIDAYS.NAME,
            label: t('TOP_NAV_COMMON.TABS.HOLIDAYS_LIST'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.HOLIDAYS_LIST}`
          },
          {
            name: AppPermissions.VACCINE.NAME,
            label: t('TOP_NAV_COMMON.TABS.VACCINES_LIST'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.VACCINES_LIST}`
          },
          {
            name: AppPermissions.D0_CONFIGURATION.NAME,
            label: t('TOP_NAV_COMMON.TABS.DO_CONFIGURATION'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.D0_CONFIGURATION}`
          },
          {
            name: AppPermissions.APPOINTMENT.NAME,
            label: t('TOP_NAV_COMMON.TABS.APPOINTMENT_TYPE'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.APPOINTMENT_TYPE}`
          },
          {
            name: AppPermissions.VOICE_ASSISTANT_CONFIG.NAME,
            label: 'Voice Agent Config',
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.VOICE_AGENT_CONFIG}`
          },
          {
            name: AppPermissions.EMR_MAPPINGS_FILE.NAME,
            label: t('TOP_NAV_COMMON.TABS.EMR_MAPPINGS_FILE'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.EMR_MAPPINGS_FILE}`
          },
          {
            name: AppPermissions.EMR_SYNC.NAME,
            label: t('TOP_NAV_COMMON.TABS.EMR_SYNC_PLATFORM'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.EMR_SYNC_PLATFORM}`
          },
          {
            name: AppPermissions.USERS.NAME,
            label: t('TOP_NAV_COMMON.TABS.USERS'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.USERS}`
          }
        ]
      : [
          {
            name: AppPermissions.DASHBOARD.NAME,
            label: t('TOP_NAV_COMMON.TABS.DASHBOARD'),
            route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.USERDASHBOARD}`
          }
        ];
  const handleAuthRedirect = (token: any, type: string): void => {
    if (token) {
      InitSharedRepo.initAfterAuth({token});
      AuthUtils.setAdminAuthToken({token, portal: 'admin'});
      if (typeof props?._login === 'function') {
        props._login(token, null, 'admin');
        props._showMessageAlert(true);
      }
    }
    if (type === BASE_ROUTE_ADMIN) {
      AuthUtils.setAdminAuthToken({token, portal: BASE_ROUTE_ADMIN});
      props._adminLogin(token, BASE_ROUTE_ADMIN);
    }
  };

  const AdminHomeRoute = `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}`;

  useEffect(() => {
    if (
      selectedGroup?.id !== groupId &&
      Object.keys(selectedGroup).length > 0
    ) {
      // set meApiCalled.current to true if the user group is changed
      meApiCalled.current = true;
    }
    if (meApiCalled?.current) {
      setLoad(true);

      getMyProfile()
        .then(
          async (res: any): Promise<any> => {
            const permissions: any = {},
              orgGroupMapping: any = {};

            let updatedGroupId = defaultGroupIdAfterAuth ?? groupId;
            // RESETTING IT
            if (defaultGroupIdAfterAuth) {
              dispatch(
                _setDefaultGroupAfterAuth({
                  clinic_group_id: null
                })
              );
            }
            if (res?.data) {
              // dispatching group type
              dispatch(_groupType(res?.data?.org_group?.group_type));
              // setting user type to storage
              if (res?.data?.user_type === 'admin') {
                // storing user type admin to redux state.
                props._userType('admin');
                Storage.setItem('userType', 'admin');
                Storage.setItem('vtAdminName', res.data.full_name);
                if (loginToken) {
                  // During login when the user_type is "admin", call the handleAuthRedirect method
                  handleAuthRedirect(loginToken, res);
                }
              } else if (res?.data?.user_type === 'user') {
                dispatch(
                  _setUserHasAdminRoleAndReportsEnable(
                    !!res?.data?.enable_reports
                  )
                );
                props._userType('user');

                const orgGroupMap = res?.data?.org_group_map;
                if (Array.isArray(orgGroupMap) && orgGroupMap.length !== 0) {
                  /* The groupId is initially set to 'org_group_id', a value retrieved from local storage.
                  Begin by verifying if the group has been deleted; if it has, opt for an alternative group to serve as the new default.
                */
                  const fallbackGroupId = orgGroupMap[0].org_group_id;
                  const doesGroupExist = orgGroupMap.some(
                    (group: any) => group?.org_group_id == updatedGroupId
                  );
                  InitSharedRepo.initClinicGroupHeader(updatedGroupId);
                  if (updatedGroupId) {
                    if (!doesGroupExist) {
                      props._groupId(fallbackGroupId);
                      // setting the groupId in headers
                      InitSharedRepo.initClinicGroupHeader(fallbackGroupId);
                      Storage.setItem('org_group_id', fallbackGroupId);
                      updatedGroupId = fallbackGroupId;
                    } else {
                      props._groupId(updatedGroupId);
                      // setting the groupId in headers
                      InitSharedRepo.initClinicGroupHeader(updatedGroupId);
                      Storage.setItem('org_group_id', updatedGroupId);
                    }
                  } else {
                    const userDefaultGroup = res?.data?.org_group_id;
                    const doesDefaultGroupExist = orgGroupMap.some(
                      (group: any) => group?.org_group_id == userDefaultGroup
                    );
                    if (doesDefaultGroupExist) {
                      props._groupId(userDefaultGroup);
                      // setting the groupId in headers
                      InitSharedRepo.initClinicGroupHeader(userDefaultGroup);
                      updatedGroupId = userDefaultGroup;
                      Storage.setItem('org_group_id', userDefaultGroup);
                    } else {
                      props._groupId(fallbackGroupId);
                      // setting the groupId in headers
                      InitSharedRepo.initClinicGroupHeader(fallbackGroupId);
                      updatedGroupId = fallbackGroupId;
                      Storage.setItem('org_group_id', fallbackGroupId);
                    }
                  }
                } else {
                  // User doesn't have access to any group
                  if (groupId) {
                    props._groupId(null);
                    // setting the groupId in headers
                    InitSharedRepo.initClinicGroupHeader(null);
                    updatedGroupId = null;
                    Storage.setItem('org_group_id', null);
                    // Redirect to the Profile Page
                  }
                  history.push(
                    `${AdminHomeRoute}/${NavRoutes.PRIVATE.PROFILE}`
                  );
                }
                props._userGroups(res?.data?.org_group_map ?? []);
                Storage.setItem('userType', 'user');
              } else {
                await logoutUserFromWeb();
                history.push(`/${NavRoutes.PUBLIC.LOGOUT}`);
              }
            }
            // Mapping Of role permissions like {object: {function: function}}
            if (res?.data?.org_group_map) {
              if (res?.data?.org_group_map?.length >= 1) {
                if (statusCode !== res.status_code) {
                  setStatusCode(res.status_code);
                }
              }
              props._userGroups(
                res?.data?.org_group_map
                  .filter((groupData: any) => groupData.org_group !== null)
                  .map((group: any) => {
                    if (!orgGroupMapping[group.org_group_id]) {
                      orgGroupMapping[group.org_group_id] = group.org_group;
                    }
                    if (group.org_group_id == updatedGroupId) {
                      props._patientsShared(
                        group.org_group.patients_shared,
                        group.org_group.emr_provider,
                        group.org_group.split_statement,
                        group.org_group.is_multi_column_mapping,
                        group.org_group.consolidated_group_billing,
                        group.org_group.billing_clinic_id,
                        group.org_group.show_only_billing_practice
                      );
                      dispatch(_groupType(group.org_group.group_type));
                    }
                    return {
                      name: group.org_group.group_name,
                      id: group.org_group_id,
                      user_org_group_type: group.user_org_group_type,
                      patients_shared: group.org_group.patients_shared,
                      emr_provider: group.org_group.emr_provider,
                      group_type: group.org_group.group_type,
                      split_statement: group.org_group.split_statement,
                      is_multi_column_mapping:
                        group.org_group.is_multi_column_mapping,
                      consolidated_group_billing:
                        group.org_group.consolidated_group_billing,
                      ccm_clinic_id: group.org_group?.ccm_clinic_id,
                      ccm: group.org_group?.ccm,
                      is_claim_tickets_cpt_codes_enabled:
                        group.org_group?.is_claim_tickets_cpt_codes_enabled
                    };
                  })
              );
            }
            if (res?.data?.user_role) {
              for (const role of res.data.user_role) {
                // checking whether each role is having permission array or not
                if (Array.isArray(role.permissions)) {
                  for (const permission of role.permissions) {
                    if (!permissions[role.org_group_id]) {
                      permissions[role.org_group_id] = {
                        group: orgGroupMapping[role.org_group_id]
                      };
                    }
                    if (!permissions[role.org_group_id][permission.object]) {
                      permissions[role.org_group_id][permission.object] = {};
                      permissions[role.org_group_id][permission.object][
                        permission.function
                      ] = permission.function;
                    } else {
                      permissions[role.org_group_id][permission.object][
                        permission.function
                      ] = permission.function;
                    }
                  }
                  delete role.permissions;
                }
              }
            }
            props._initUserInfo({userInfo: res.data});
            props._initUserPermissions({userPermissions: permissions});
            // ASK: Do we need the below one??
            // if (!updatedGroupId) {
            //   props._patientsShared(
            //     res?.data?.org_group?.patients_shared,
            //     res?.data?.org_group?.emr_provider,
            //     res?.data?.org_group?.split_statement,
            //     res?.data?.org_group?.is_multi_column_mapping
            //   );
            // }
          }
        )
        .catch(err => {
          if (typeof err.status_code === 'number')
            setStatusCode(err.status_code);
        })
        .finally(() => {
          setLoad(false);
        });
    }
    // Outside the loop set "meApiCalled" useRef to false
    meApiCalled.current = false;

    // setTabs(defaultTabs);
  }, [groupId, tab, statusCode]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    //  check the ccm timer is running or not, if it is running then switch to that group
    const ccmTimerJSONInfo = Storage.getItem(
      CCMConstants.STORAGE_CCM_TIMER_DATA
    );
    if (ccmTimerJSONInfo) {
      const ccmTimerParsedInfo = JSON.parse(ccmTimerJSONInfo);
      if (ccmTimerParsedInfo?.groupId) {
        // TODO: check whether user still has access to that group or not ????
        props._groupId(ccmTimerParsedInfo?.groupId);
        // if(ccmTimerParsedInfo?.clinicId){
        //   dispatch(_statementsSelectedClinic([ccmTimerParsedInfo?.clinicId]))
        // }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Prior AUth Group Condition
  useEffect(() => {
    //  check the ticket timer is running or not, if it is running then switch to that group
    const ticketTimerJSONInfo = Storage.getItem(
      PriorAuthConstants.STORAGE_PRIOR_AUTH_TIMER_DATA
    );
    if (ticketTimerJSONInfo) {
      const ticketTimerParsedInfo = JSON.parse(ticketTimerJSONInfo);
      if (ticketTimerParsedInfo?.clinicGroupId) {
        // TODO: check whether user still has access to that group or not ????
        props._groupId(ticketTimerParsedInfo?.clinicGroupId);
        const {startTime, ticketId, patientId, logId} = ticketTimerParsedInfo;
        dispatch(_startTicketTimer(startTime, ticketId, patientId, logId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ** New Changes Start --> **//
  const BASE_ROUTE = `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}`;
  const moduleRouteMapperByModuleId: {[key: string]: string} = {
    patients: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.PATIENTS}`,
    appointments: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.APPOINTMENTS}`,
    statements: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.INVOICES}`,
    payments: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.PAYMENTS}`,
    messages: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.INCOMING_SMS}`,
    patient_recalls: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.PATIENT_RECALL}`,
    ccm: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.CCM}`,
    prior_authorizations_tickets: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.PRIOR_AUTHORIZATIONS}`,
    claims_tickets: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.CLAIMS_TICKETS}`,
    referrals_tickets: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.REFERRAL_TICKETS}`,
    patient_forms: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.PATIENT_FORM}`,
    claims: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.CLAIMS}`,
    emr_sync: `${BASE_ROUTE}/${NavRoutes.PRIVATE.ADMIN.EMR_SYNC}`
  };
  // ** Fetching the modules from the API and storing them redux to access them -> START ** //
  const fetchAvailableModules = async () => {
    try {
      const response = await getGroupLevelEnabledModules();
      if (response?.data) {
        dispatch(_setSelectedGroupEnabledModules(response?.data));
      }
    } catch (err: any) {
      enqueueSnackbar('Error in fetching the modules');
    }
  };

  useEffect(() => {
    fetchAvailableModules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  const excludedModuleIds: any = [
    'card_machines',
    'eligibility_verification',
    'patient_portal'
  ];

  // Default Menu Items
  const DefaultMenuPopOverItems: Array<CustomPopOverListItemType> = [
    {
      name: AppPermissions.DASHBOARD.NAME,
      id: 'DASHBOARD',
      label: t('TOP_NAV_COMMON.TABS.DASHBOARD'),
      route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.USERDASHBOARD}`
    },
    {
      name: AppPermissions.CLINIC.NAME,
      id: 'CLINICS',
      route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.CLINICS}`,
      label: t('TOP_NAV_COMMON.TABS.CLINICS')
    },
    {
      name: AppPermissions.REPORTS.NAME,
      id: 'REPORTS',
      route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.REPORTS}`,
      label: t('TOP_NAV_COMMON.TABS.REPORTS')
    },
    {
      name: AppPermissions.PATIENT_REVIEW.NAME,
      id: 'GATHERED_FEEDBACK',
      route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.GATHERED_FEEDBACK}`,
      label: t('TOP_NAV_COMMON.TABS.GATHERED_FEEDBACK')
    },
    {
      name: AppPermissions.PATIENT.NAME,
      id: 'EMR_SYNC',
      route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.EMR_SYNC}`,
      label: t('TOP_NAV_COMMON.TABS.EMR_SYNC'),
      menuPermissionName: 'patients'
    }
  ];

  // Initialize with default items
  const [menuDropDownOptions, setMenuOptions] = useState<any>([]);

  useEffect(() => {
    const updatedMenuOptions = [...DefaultMenuPopOverItems];

    accessableModules?.system_modules?.rows.forEach((item: any) => {
      // Skip e,xcluded modules to not show up in the menu dropdown
      if (excludedModuleIds.includes(item.module_name_id)) {
        return;
      }
      // ** Creating an object as per requirement of defaultMenuPopOberItems array as above **//
      const menuItem: any = {
        id: item.module_name_id,
        name: moduleNameMapper[item.module_name_id], // using the module_name_id to define the name here instead of module_name to vcheck permissions
        route: moduleRouteMapperByModuleId[item.module_name_id],
        label: t(moduleNameTransMapperByModuleId[item.module_name_id]),
        menuPermissionName: item.module_name_id
      };
      // Special format for 'messages' for custom badge
      if (item.module_name_id === 'messages') {
        menuItem.label = (
          <div className={classes.notificationLabel}>
            {t('TABS.INCOMING_SMS')}
            <span className={classes.custom}>
              <CustomBadge count={count} />
            </span>
          </div>
        );
      }
      // updatedMenuOptions.push(menuItem);
      // ** to maintain the order we are splicing the object **//
      updatedMenuOptions.splice(-2, 0, menuItem);
    });

    setMenuOptions(updatedMenuOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientsEnable, accessableModules]);

  // ** Fetching the modules from the API and storing them redux to access them -> END ** //

  const MenuPopOverItem1: Array<CustomPopOverListItemType> = [
    {
      name: AppPermissions.DASHBOARD.NAME,
      id: 'DASHBOARD',
      label: t('TOP_NAV_COMMON.TABS.DASHBOARD'),
      route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.USERDASHBOARD}`
    },
    {
      name: AppPermissions.CLINIC.NAME,
      id: 'CLINICS',
      route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.CLINICS}`,
      label: t('TOP_NAV_COMMON.TABS.CLINICS')
    }
  ];

  const hasPriorAuthPermission = usePriorAuthPermission();
  const hasClaimsTicketsPermission = useClaimsTicketsPermissions();
  const hasReferralsTicketsPermission = useReferralsTicketsPermissions();

  const hasPatientReviewPermission = React.useMemo(() => {
    // USER DOESN'T HAVE CCM PERMISSION
    if (
      !Permission.hasFeedBackPermissions(
        userPermissions,
        AppPermissions.PATIENT_REVIEW.LIST,
        groupId
      )
    ) {
      return false;
    }
    // ** checking the clinic is belonging to that particular group or not */
    const hasClinicListBeenUpdated = clinicsList.some(
      (cl: any) => cl.org_group_id === groupId
    );
    if (!hasClinicListBeenUpdated) {
      return false;
    }
    if (Array.isArray(clinicsList)) {
      return clinicsList.some(
        (cl: any) => cl?.is_patient_review_enabled === true
      );
    }
    return false;
  }, [userPermissions, groupId, clinicsList]);

  const hasCCMPermission = React.useMemo(() => {
    // USER DOESN'T HAVE CCM PERMISSION
    if (
      !Permission.hasCCMPermissions(
        userPermissions,
        AppPermissions.CCM.LIST,
        groupId
      )
    ) {
      return false;
    }

    // IF PATIENT SHARED IS ON THEN CCM MUST BE ENABLED AT GROUP
    if (
      userPermissions?.[groupId]?.['group']?.[
        AppPermissions.PATIENT_MENU_PERMISSIONS.PATIENT_SHARED
      ] === true &&
      userPermissions?.[groupId]?.['group']?.[
        AppPermissions.CCM_MENU_PERMISSIONS.CCM
      ] === true
    ) {
      return true;
    }

    const hasClinicListBeenUpdated = clinicsList.some(
      (cl: any) => cl.org_group_id === groupId
    );
    if (!hasClinicListBeenUpdated) {
      return false;
    }
    if (
      userPermissions?.[groupId]?.['group']?.[
        AppPermissions.PATIENT_MENU_PERMISSIONS.PATIENT_SHARED
      ] === false &&
      Array.isArray(clinicsList)
    ) {
      return clinicsList.some((cl: any) => cl?.is_ccm_enabled === true);
    }
    return false;
  }, [userPermissions, groupId, clinicsList]);

  const renderUserTypeTabs = (): any => {
    // let newTabs = MenuPopOverItem || [];
    let newTabs =
      groupType !== ORGANIZATION_GROUP_TYPES.BILLING_GROUP_VALUE
        ? menuDropDownOptions
        : MenuPopOverItem1;
    if (newTabs?.length > 0) {
      if (userType === 'user') {
        newTabs = newTabs.filter((ta: any) => {
          if (
            ta?.name == AppPermissions.CLINIC.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name]
          ) {
            return userPermissions[groupId][AppPermissions.CLINIC.NAME][
              AppPermissions.CLINIC.EDIT
            ];
          } else if (
            ta?.name == AppPermissions.PATIENT.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name] &&
            userPermissions[groupId]['group']
          ) {
            return userPermissions[groupId]['group'][ta?.menuPermissionName];
          } else if (
            ta?.name == AppPermissions.STATEMENT.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name] &&
            userPermissions[groupId]['group']
          ) {
            return userPermissions[groupId]['group'][ta?.menuPermissionName];
          } else if (
            ta?.name == AppPermissions.APPOINTMENT.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name] &&
            userPermissions[groupId]['group']
          ) {
            return userPermissions[groupId]['group'][ta?.menuPermissionName];
          } else if (
            ta?.name == AppPermissions.PAYMENT_HISTORY.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name] &&
            userPermissions[groupId]['group']
          ) {
            return userPermissions[groupId]['group'][ta?.menuPermissionName];
          } else if (
            ta?.name == AppPermissions.PATIENT_RECALL.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name] &&
            userPermissions[groupId]['group']
          ) {
            return userPermissions[groupId]['group'][ta?.menuPermissionName];
          } else if (
            ta?.name == AppPermissions.INCOMING_SMS.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name] &&
            userPermissions[groupId]['group']
          ) {
            return userPermissions[groupId]['group'][ta?.menuPermissionName];
          } else if (
            ta?.name == AppPermissions.CCM.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name]
          ) {
            return hasCCMPermission;
          }
          // CHECKING USER HAS PRACTICE ADMIN ROLE AND ENABLE REPORTS TRUE --> START.
          else if (
            ta?.name == AppPermissions.REPORTS.NAME &&
            userHasAdminRoleAndReportsEnable
          ) {
            return true;
          }
          // CHECKING USER HAS PRACTICE ADMIN ROLE AND ENABLE REPORTS TRUE --> END.
          else if (ta?.name == AppPermissions.PATIENT_REVIEW.NAME) {
            return hasPatientReviewPermission;
          } else if (ta.name === AppPermissions.PRIOR_AUTHORIZATION.NAME) {
            return hasPriorAuthPermission;
          } else if (ta.name === AppPermissions.CLAIMS_TICKETS.NAME) {
            return hasClaimsTicketsPermission;
          } else if (ta.name === AppPermissions.REFERRALS_TICKETS.NAME) {
            return hasReferralsTicketsPermission;
          } else if (ta.name === AppPermissions.DASHBOARD.NAME) {
            return true;
          } else if (
            ta?.name == AppPermissions.PATIENT_FORMS.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name] &&
            userPermissions[groupId]['group']
          ) {
            return userPermissions[groupId]['group'][ta?.menuPermissionName];
          } else if (
            ta.name === AppPermissions.CLAIM.NAME &&
            userPermissions[groupId] &&
            userPermissions[groupId][ta?.name] &&
            userPermissions[groupId]['group']
          ) {
            return userPermissions[groupId]['group'][ta?.menuPermissionName];
          }
          // ** return true to show up the D0 configuration in the super admin screen ** //
          else if (ta.name === AppPermissions.D0_CONFIGURATION.NAME) {
            return true;
          } else if (ta.name === AppPermissions.VOICE_ASSISTANT_CONFIG.NAME) {
            return true;
          } else {
            return (
              typeof userPermissions[groupId] !== 'undefined' &&
              typeof userPermissions[groupId][ta?.name] !== 'undefined'
            );
          }
        });
      }
      // TODO: need an enhancement here --> find another way to fix the logic
      // Modify the return based on the length of newTabs to navigate to the profile screen if no module is enabled
      // ** based on the groupType and the objects present in the newTabs the required operations are made **//
      if (
        (newTabs.length === 2 || newTabs.length === 1) &&
        groupType !== ORGANIZATION_GROUP_TYPES.BILLING_GROUP_VALUE
      ) {
        // Check if only Dashboard and Clinic objects are present
        const isOnlyDashboardAndClinic =
          (newTabs.length === 1 || newTabs.length === 2) &&
          (newTabs.some((tabId: any) => tabId.id === MENUOPTIONS.DASHBOARD) ||
            newTabs.some((tabId: any) => tabId.id === MENUOPTIONS.CLINICS));

        if (isOnlyDashboardAndClinic) {
          newTabs = newTabs.filter(
            (tabId: any) => tabId.id !== MENUOPTIONS.DASHBOARD
          );
        }
        return newTabs;
      } else if (newTabs.length === 0) {
        return [];
      } else {
        return newTabs;
      }
    } else {
      return [];
    }
  };

  React.useEffect(() => {
    if (userType === 'admin') {
      const newTabs = defaultTabs;
      // setTabs(newTabs);
      let checkIndex = 0;
      newTabs.forEach((item: any, index: number) => {
        if (location.pathname.includes(item.route)) {
          checkIndex = index;
        }
      });
      if (newTabs[checkIndex]) {
        setTabs([newTabs[checkIndex]]);
      } else if (newTabs?.length === 0) {
        // if tabs length is zero navigate to the profile screen
        const profile = `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.PROFILE}`;
        history.push(profile);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      defaultTabs = [newTabs[checkIndex]];
    } else if (
      userType === 'user' &&
      userPermissions &&
      Object.keys(userPermissions).length
    ) {
      const newTabs = renderUserTypeTabs();
      let checkIndex = 0;
      newTabs?.forEach((item: any, index: number) => {
        if (location.pathname.includes(item.route)) {
          checkIndex = index;
        }
      });
      if (newTabs[checkIndex]) {
        setTabs([newTabs[checkIndex]]);
      } else if (newTabs?.length === 0) {
        // if tabs length is zero navigate to the profile screen
        const profile = `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.PROFILE}`;
        history.push(profile);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      defaultTabs = [newTabs[checkIndex]];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId, userPermissions, userGroups, switchTab, count]);

  useEffect(() => {
    if (tabs.length) {
      tabs.forEach((item, index) => {
        if (location.pathname.includes(item.route)) {
          setTab(index);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const reloadBrowser = () => {
    window.location.reload();
  };
  // monitor for changes to the local storage version update, and show a dialog
  // todo: what is the right way to monitor the flag change?
  React.useEffect(() => {
    // if there is an update available and no state passed to route
    subscription.current = CommunicationService.getEvent().subscribe(data => {
      if (data.action === 'APP_VERSION_UPDATED') {
        setNewUpdateAlert(true);
      }
      // navigating to the appointments tab if view appointment action is triggered in dashboard CCM Appointments Card for a particular patient
      else if (data.action === 'NAVIGATE_TO_APPOINTMENT_TAB') {
        const appointmentObject = {
          name: AppPermissions.APPOINTMENT.NAME,
          id: 'APPOINTMENTS',
          route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.APPOINTMENTS}`,
          label: t('TOP_NAV_COMMON.PATIENT_TAB.APPOINTMENTS')
          // data: data?.data
        };
        dispatch(_setUpcomingAppointment(data?.data));
        setTabs([appointmentObject]);
      }
    });
    return () => {
      subscription.current?.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const renderErrorMessage = (): React.ReactElement => {
    return (
      <div className={classes.dropDownErrorClass}>
        {t('DASHBOARD.USER_DASHBOARD_CARD_TITLE.ERROR_MESSAGE')}
      </div>
    );
  };
  const renderHomeRoutes = () => {
    const {params, routes} = props;
    // setting up user to redux State;
    const route = routes.map((r: any, i: any) => {
      return CustomRoute.privateRouting({
        key: i,
        path: r.path,
        exact: r.exact,
        Component: r.component,
        exactFrom: r.exactFrom,
        redirectTo: r.redirectTo,
        routes: r.routes
      });
    });
    return (
      <React.Suspense fallback={<LinearProgress />}>
        <Switch>
          <Redirect
            from={`/${params}/${NavRoutes.PRIVATE.HOME}`}
            to={
              userType === 'admin'
                ? `/${params}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.DASHBOARD}`
                : `/${params}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.USERDASHBOARD}`
            }
            exact
          />
          {route}
          <Redirect
            to={
              userType === 'admin'
                ? `/${params}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.DASHBOARD}`
                : `/${params}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.USERDASHBOARD}`
            }
          />
        </Switch>
      </React.Suspense>
    );
  };

  React.useEffect(() => {
    if (tabs[tab]) {
      const ccmURLPath = `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.CCM}`;
      const targetRoute = tabs[tab]?.route;
      if (
        location.pathname.startsWith(tabs[tab]?.route) &&
        tabs[tab]?.route === ccmURLPath
      ) {
        // Don't update if It is already on CCM Tabs
      } else if (
        location.pathname === targetRoute ||
        (targetRoute && location.pathname.startsWith(`${targetRoute}/`))
      ) {
        // Already on this module route — keep current URL (including query params)
      } else {
        history.push(targetRoute);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, tabs]);

  const handleTabChange = (newValue: number): void => {
    setTab(newValue);
    // history.push(
    //   `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.USERDASHBOARD}`
    // );
  };

  useInterval(async () => {
    if (
      groupType &&
      groupType !== ORGANIZATION_GROUP_TYPES.BILLING_GROUP_VALUE
    ) {
      if (
        userType !== 'admin' &&
        Permission.hasIncomingSmsPermissions(
          userPermissions,
          AppPermissions.INCOMING_SMS.LIST,
          groupId
        )
      ) {
        dispatch(_messageCount(groupId));
      }
    }
  }, 300000);

  const getCCMPanelData = () => {
    const initialTimerDataStr = Storage.getItem(
      CCMConstants.STORAGE_CCM_TIMER_DATA
    );
    let initialCcmPanelData: any = null;
    if (initialTimerDataStr) {
      const parsedTimerData = JSON.parse(initialTimerDataStr);
      if (parsedTimerData && parsedTimerData?.ccmPanelData) {
        initialCcmPanelData = parsedTimerData?.ccmPanelData;
      }
    }
    return initialCcmPanelData;
  };

  const getPriorAuthTicketPanelData = () => {
    const initialTicketTimerDataStr = Storage.getItem(
      PriorAuthConstants.STORAGE_PRIOR_AUTH_TIMER_DATA
    );
    let initialTicketPanelData: any = null;
    if (initialTicketTimerDataStr) {
      const parsedTimerData = JSON.parse(initialTicketTimerDataStr);
      if (parsedTimerData && parsedTimerData?.ticketPanelData) {
        initialTicketPanelData = parsedTimerData?.ticketPanelData;
      }
    }
    return initialTicketPanelData;
  };
  // Commented below lines of code, no need for the below lines of code as we are already dispatching an action event in UserDashboard.tsx file
  // useEffect(() => {
  //   if (
  //     userType !== 'admin' &&
  //     Permission.hasIncomingSmsPermissions(
  //       userPermissions,
  //       AppPermissions.INCOMING_SMS.LIST,
  //       groupId
  //     )
  //   ) {
  //     if (
  //       groupType &&
  //       groupType !== ORGANIZATION_GROUP_TYPES.BILLING_GROUP_VALUE
  //     ) {
  //       dispatch(_messageCount(groupId));
  //     }
  //   }
  // }, [count, dispatch, groupId, userType, userPermissions, groupType]);

  return (
    <div className={classes.root}>
      <TopAppBar
        tabs={tabs?.map(item => item?.label)}
        tabValue={tab}
        handleTabChange={(event, newValue) => {
          handleTabChange(newValue);
        }}
        handleDrawerToggle={() => handleDrawerToggle()}
        handleRoute={(item: any) => {
          setTabs([item]);
          const newTabs: any = [item];
          defaultTabs = newTabs;
        }}
        className={classes.appBar}
        list={
          userType === 'admin'
            ? defaultTabs
            : userPermissions
            ? renderUserTypeTabs()
            : []
        }
        handleLoader={() => {
          setLoad(true);
        }}
      />
      <main className={classes.content}>
        {load ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <Loader />
          </div>
        ) : statusCode === 405 || selectedGroup === 0 ? (
          renderErrorMessage()
        ) : load ? (
          <Loader />
        ) : (
          renderHomeRoutes()
        )}
      </main>
      <AlertBox
        open={showNewUpdateAlert}
        title={t('APP.UPDATE_ALERT_TITLE')}
        description={t('APP.UPDATE_ALERT_DESCRIPTION')}
        importantAlert
        primaryButton
        onClose={result => {
          if (result === 'confirm') {
            reloadBrowser();
          }
        }}
      />
      {patientDetailsDrawerOpen && (
        <PatientsDetailsHome openHomeDrawer={patientDetailsDrawerOpen} />
      )}
      {ccmIsRunning && (
        <DraggableCCMCard
          groupId={groupId}
          initialCcmPanelData={getCCMPanelData()}
        />
      )}
      {ticketIsRunning && (
        <DraggableTicketingSystemTicketTimerCard
          clinicGroupId={groupId}
          initialTicketPanelData={getPriorAuthTicketPanelData()}
        />
      )}
    </div>
  );
};
function mapStateToProps(state: any) {
  return {
    userType: state.auth.userType,
    user: state.auth.user,
    groupId: state.auth.groupId,
    count: state.newMessages.count,
    userPermissions: state.auth.userPermissions,
    groupName: state.auth?.user?.org_group?.group_name
  };
}
export default connect(mapStateToProps, {
  _initUserInfo,
  _initUserPermissions,
  _messageCount,
  _userGroups,
  _groupId,
  _userType,
  _patientsShared
})(Home);
